import { Path } from '@/main/router/routerPath';

import List from './List.vue';
import { CRUMB_LABEL_EDIT, NAME } from './constants';
import Edit from './Edit.vue';

export const router = new Path(NAME, { List, Edit, SelectList: List }, CRUMB_LABEL_EDIT);
